import { IApiError } from '@/models/apiError.model';
import { IPaymentMethod } from '@/models/paymentMethod.model';

export const SLICE_NAME = 'paymentMethods';

export interface IPaymentMethodsState {
  paymentMethods: IPaymentMethod[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: IPaymentMethodsState = {
  paymentMethods: null,
  isLoading: false,
  error: null,
};
